import React from 'react';
import { Navigate, Outlet, useOutletContext } from 'react-router-dom'; // 1. Importer useOutletContext
import useAuth from '../../hooks/useAuth';

const ProtectedRoute = ({ moduleKey }) => {
    const { user } = useAuth();
    
    // 2. Récupérer le contexte venant du Layout (setIsNavbarVisible, etc.)
    const context = useOutletContext();

    const hasAccess = () => {
        if (!user) return false;
        if (!user.permissions) return true;
        return user.permissions[moduleKey] === true; 
    };

    if (!hasAccess()) {
        return <Navigate to="/home" replace />;
    }

    // 3. Transmettre ce contexte à l'Outlet enfant (ProcessPage)
    return <Outlet context={context} />;
};

export default ProtectedRoute;